import React from 'react';
import { Link } from 'react-router-dom';
import { Paintbrush, Fingerprint } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <div className="flex items-center">
                <Paintbrush className="h-6 w-6 text-purple-500" />
                <Fingerprint className="h-6 w-6 text-pink-500 -ml-1" />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent">
                TattooNailGenius
              </span>
            </Link>
            <p className="mt-4 text-gray-400 text-sm">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.navigation')}</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-pink-500 transition-colors">{t('header.home')}</Link></li>
              <li><Link to="/tattoo-design" className="text-gray-400 hover:text-pink-500 transition-colors">{t('header.tattooDesign')}</Link></li>
              <li><Link to="/nail-design" className="text-gray-400 hover:text-pink-500 transition-colors">{t('header.nailDesign')}</Link></li>
              <li><Link to="/gallery" className="text-gray-400 hover:text-pink-500 transition-colors">{t('header.gallery')}</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-pink-500 transition-colors">{t('header.about')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.legal')}</h3>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-gray-400 hover:text-pink-500 transition-colors">{t('footer.termsOfService')}</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-pink-500 transition-colors">{t('footer.privacyPolicy')}</Link></li>
              <li><Link to="/cookies" className="text-gray-400 hover:text-pink-500 transition-colors">{t('footer.cookiePolicy')}</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-pink-500 transition-colors">{t('footer.copyright')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-2">
              <li className="text-gray-400">{t('footer.email')}</li>
              <li className="text-gray-400">{t('footer.support')}</li>
              <li className="text-gray-400">{t('footer.partnerships')}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">{t('footer.copyright2025')}</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/terms" className="text-gray-500 hover:text-pink-500 text-sm transition-colors">{t('footer.terms')}</Link>
            <Link to="/privacy" className="text-gray-500 hover:text-pink-500 text-sm transition-colors">{t('footer.privacy')}</Link>
            <Link to="/cookies" className="text-gray-500 hover:text-pink-500 text-sm transition-colors">{t('footer.cookies')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;